import React, {Component} from 'react';

class DentistRegistrationForm extends Component {
    render() {
        return (
            <div className="dentist-modal">
                <form>
                    <div className="dentist-modal__name">
                        <div
                            className={(this.props.validation.first_name.valid === undefined || this.props.validation.first_name.valid) ? "text-field" : "text-field has-error"}
                        >
                            <label className="text-field__label" htmlFor="dentist-first">First Name</label>
                            <input
                                className="text-field__input"
                                id="dentist-first"
                                type="text"
                                value={this.props.user.first_name}
                                onBlur={(e) => this.props.handleBlur('first_name', e.target.value)}
                                onChange={(e) => this.props.handleChange('first_name', e.target.value)}
                            />
                            <span className="error-message">{this.props.validation.first_name.message}</span>
                        </div>
                        <div
                            className={(this.props.validation.last_name.valid === undefined || this.props.validation.last_name.valid) ? "text-field" : "text-field has-error"}
                        >
                            <label className="text-field__label" htmlFor="dentist-last">Last Name</label>
                            <input
                                className="text-field__input"
                                id="dentist-last"
                                type="text"
                                value={this.props.user.last_name}
                                onBlur={(e) => this.props.handleBlur('last_name', e.target.value)}
                                onChange={(e) => this.props.handleChange('last_name', e.target.value)}
                            />
                            <span className="error-message">{this.props.validation.last_name.message}</span>
                        </div>
                    </div>
                    <div
                        className="text-field"
                    >
                        <label className="text-field__label" htmlFor="dentist-last">License</label>
                        <input
                            className="text-field__input"
                            id="dentist-last"
                            type="text"
                            value={this.props.user.license}
                            onBlur={(e) => this.props.handleBlur('license', e.target.value)}
                            onChange={(e) => this.props.handleChange('license', e.target.value)}
                        />
                        {/*<span className="error-message">{this.props.validation.license.message}</span>*/}
                    </div>
                    <div
                        className={(this.props.validation.email.valid === undefined || this.props.validation.email.valid) ? "text-field" : "text-field has-error"}
                    >
                        <label className="text-field__label" htmlFor="dentist-email">Email Address</label>
                        <input
                            className="text-field__input"
                            id="dentist-email"
                            type="text"
                            value={this.props.user.email}
                            onBlur={(e) => this.props.handleBlur('email', e.target.value)}
                            onChange={(e) => this.props.handleChange('email', e.target.value)}
                            placeholder="Someone@xyz.com"
                        />
                        <span className="error-message">{this.props.validation.email.message}</span>
                    </div>
                    <div
                        className={(this.props.validation.username.valid === undefined || this.props.validation.username.valid) ? "text-field" : "text-field has-error"}
                    >
                        <label className="text-field__label" htmlFor="dentist-username">Username</label>
                        <input
                            className="text-field__input"
                            id="dentist-username"
                            type="text"
                            value={this.props.user.username}
                            onBlur={(e) => this.props.handleBlur('username', e.target.value)}
                            onChange={(e) => this.props.handleChange('username', e.target.value)}
                            placeholder="Username"
                        />
                        <span className="error-message">{this.props.validation.username.message}</span>
                    </div>
                    <div
                        className={(this.props.validation.password.valid === undefined || this.props.validation.password.valid) ? "text-field" : "text-field has-error"}
                    >
                        <label className="text-field__label" htmlFor="dentist-pass">Password</label>
                        <input
                            autoComplete="new-password"
                            className="text-field__input"
                            id="dentist-pass"
                            type="password"
                            onBlur={(e) => this.props.handleBlur('password', e.target.value)}
                            onChange={(e) => this.props.handleChange('password', e.target.value)}
                            placeholder="Password"
                        />
                        <span className="error-message">{this.props.validation.password.message}</span>
                    </div>
                    <div
                        className={(this.props.validation.confirm_password && this.props.validation.confirm_password.valid === undefined || this.props.validation.confirm_password && this.props.validation.confirm_password.valid) ? "text-field" : "text-field has-error"}
                    >
                        <label className="text-field__label" htmlFor="dentist-confirm-pass">Confirm Password</label>
                        <input
                            autoComplete="confirm-password"
                            className="text-field__input"
                            id="dentist-confirm-pass"
                            type="password"
                            onBlur={(e) => this.props.handleBlur('confirm_password', e.target.value)}
                            onChange={(e) => this.props.handleChange('confirm_password', e.target.value)}
                            placeholder="Confirm Password"
                        />
                        <span className="error-message">{this.props.validation.confirm_password && this.props.validation.confirm_password.message}</span>
                    </div>
                </form>
            </div>
        );
    }
}


export default DentistRegistrationForm;



// WEBPACK FOOTER //
// ./src/components/DentistRegistrationForm/index.js